export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    COURIER_USER_ALL: function COURIER_USER_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/courier-user/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    COURIER_USER_CREATE: function COURIER_USER_CREATE(data) {
      return request({
        url: '/api/courier-user/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    COURIER_USER_DETAIL: function COURIER_USER_DETAIL(id) {
      return request({
        url: '/api/courier-user/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    COURIER_USER_UPDATE: function COURIER_USER_UPDATE(data) {
      return request({
        url: '/api/courier-user/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    COURIER_USER_DELETE: function COURIER_USER_DELETE(id) {
      return request({
        url: '/api/courier-user/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    },
    COURIER_USER_BLACK: function COURIER_USER_BLACK(user_mobile, black) {
      return request({
        url: '/api/courier-user/black',
        method: 'post',
        data: {
          user_mobile: user_mobile,
          black: black
        }
      });
    }
  };
});